var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatchedTrials(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "58px",
    viewBox: "0 0 61 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Matched trials") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.00997875,0 C2.24304389,0 0,2.24553095 0,5.00003191 L0,44.9999681 C0,47.7614095 2.24349151,50 5.00997875,50 L53,50 L53,0 L5.00997875,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.2%",
    y: "-10.0%",
    width: "126.4%",
    height: "128.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 19.5,
    cy: 19.5,
    r: 19.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WEBAPP-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-like-me-mobile01",
    transform: "translate(-263.000000, -497.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "match2",
    transform: "translate(267.000000, 499.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paper-shadow-z=\"1\"-copy-10"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0C9BED",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(7.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDD9A3",
    cx: 9.5,
    cy: 27,
    rx: 9.5,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,6 L18,6 L18,25 C18,26.1045695 17.1045695,27 16,27 L4,27 C2.8954305,27 2,26.1045695 2,25 L2,6 L2,6 Z",
    id: "Rectangle",
    fill: "#FBFBE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L18,0 L18,5 C18,5.55228475 17.5522847,6 17,6 L3,6 C2.44771525,6 2,5.55228475 2,5 L2,0 L2,0 Z",
    id: "Rectangle-Copy-8",
    fill: "#9E6FD4",
    transform: "translate(10.000000, 3.000000) scale(1, -1) translate(-10.000000, -3.000000) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8B58D8",
    x: 8,
    y: 1,
    width: 1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    fill: "#8B58D8",
    x: 6,
    y: 1,
    width: 1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    fill: "#8B58D8",
    x: 5,
    y: 1,
    width: 1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    fill: "#8B58D8",
    x: 3,
    y: 1,
    width: 1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    fill: "#8B58D8",
    x: 10,
    y: 1,
    width: 1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    fill: "#8B58D8",
    x: 11,
    y: 1,
    width: 1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    fill: "#8B58D8",
    x: 12,
    y: 1,
    width: 1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    fill: "#8B58D8",
    x: 14,
    y: 1,
    width: 1,
    height: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-9",
    fill: "#59BBAC",
    transform: "translate(5.500000, 14.500000) scale(-1, -1) rotate(90.000000) translate(-5.500000, -14.500000) ",
    points: "-2 11 13 11 13 18 -2 18"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FEFEFD",
    x: 2,
    y: 11,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    fill: "#FEFEFD",
    x: 2,
    y: 14,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-11",
    fill: "#FEFEFD",
    points: "3 17 6 17 6 18 3 18"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchedTrials);
export default __webpack_public_path__ + "static/media/matchedTrials.13966932b68c9650262a2cbf656600bc.svg";
export { ForwardRef as ReactComponent };